import React, { useState } from "react";
import { Container, Row } from "react-bootstrap";
import FsLightbox from "fslightbox-react";
import "../Pages/Pages.css";

import { mens } from "./constants/mensImages";

export default function MansProducts() {
  const [toggler, setToggler] = useState(false);
  return (
    <div>
      <div className="mens_header_bg">
        <h3>Mens Products</h3>
      </div>
      <div className="mens_content">
        <Container>
          <Row>
            {mens.map((item, index) => (
              <div className="col-md-3 col-sm-3 col-6">
                <div className="card my-3">
                  <div className="card-body">
                    <a
                      className="gallery_img"
                      onClick={() => setToggler(!toggler)}
                    >
                      <img
                        className="img-fluid"
                        key={index}
                        src={item.image}
                        alt="jnc_mens"
                      />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </Row>
          <FsLightbox
            toggler={toggler}
            sources={mens.map((item) => {
              return item.image;
            })}
          />
        </Container>
      </div>
    </div>
  );
}
